var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.404 2.595A1.952 1.952 0 0020.006 2c-.53 0-1.029.217-1.399.595l-13.5 14.143a1.921 1.921 0 00.065 2.724 1.928 1.928 0 002.724-.065L18.077 8.742v27.33c0 1.068.86 1.928 1.929 1.928 1.068 0 1.928-.86 1.928-1.929V8.742l10.173 10.663c.74.772 1.953.796 2.724.065a1.928 1.928 0 00.065-2.724l-13.5-14.143.008-.008z"
  })));
}
export default SvgArrowUp;